import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useMemo } from 'react';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { getLinkTo } from '@atlassian/commerce-links';
import { withBreadcrumb } from '@atlassian/commerce-telemetry/dispatch-hooks';
import { CC_ERROR_BOUNDARY } from '../../../common/constants/breadcrumb-names';
import { I18nHack, isJapaneseLanguage, usePreferredLanguage } from '../../../common/utils/i18n-hack';
import { useCreditCardRetry } from '../../../controllers/hooks/use-credit-card-retry';

var ErrorCreditCardWithoutBreadcrumb = function ErrorCreditCardWithoutBreadcrumb() {
  var retry = useCreditCardRetry();
  var language = usePreferredLanguage();
  var isJapanese = useMemo(function () {
    return language !== undefined && isJapaneseLanguage(language);
  }, [language]);
  var title = isJapanese ? 'クレジットカードの支払いフォームをロードできません' : 'Problem connecting';
  var retryText = isJapanese ? 'リロード' : 'Try again';
  var contactSupportText = isJapanese ? 'お問い合わせ' : 'Contact support';
  return (
    /*#__PURE__*/
    // div is required to unbound SectionMessage from 100% height style from the parent
    React.createElement("div", null, /*#__PURE__*/React.createElement(SectionMessage, {
      appearance: "error",
      title: title,
      actions: [{
        key: 'retry',
        onClick: retry,
        text: retryText
      }, {
        key: 'support',
        href: getLinkTo('support', 'en'),
        text: contactSupportText
      }].map(function (_ref) {
        var text = _ref.text,
            restAction = _objectWithoutProperties(_ref, ["text"]);

        return /*#__PURE__*/React.createElement(SectionMessageAction, restAction, text);
      })
    }, /*#__PURE__*/React.createElement(I18nHack, {
      en: "We're sorry, we can't load the credit card form right now.",
      ja: "\u652F\u6255\u3044\u306E\u51E6\u7406\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u652F\u6255\u3044\u60C5\u5831\u3092\u78BA\u8A8D\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"
    })))
  );
};

export var ErrorCreditCard = withBreadcrumb(ErrorCreditCardWithoutBreadcrumb, CC_ERROR_BOUNDARY);